<script>
    import {twMerge} from "$m7-library/lib/twMerge";

    const {class: cls = "", width = "24", height = "24"} = $props()
</script>

<svg class={twMerge("tw:text-cyprus tw:h-6 tw:w-6", cls)} width="{width}" height="{height}" viewBox="0 0 18.75 18.75" fill="none"
     xmlns="http://www.w3.org/2000/svg">
    <path d="M15.625 3.90625H3.125C2.26206 3.90625 1.5625 4.60581 1.5625 5.46875V13.2812C1.5625 14.1442 2.26206 14.8438 3.125 14.8438H15.625C16.4879 14.8438 17.1875 14.1442 17.1875 13.2812V5.46875C17.1875 4.60581 16.4879 3.90625 15.625 3.90625Z" stroke="currentColor" stroke-width="1.5625" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1.5625 7.8125H17.1875" stroke="currentColor" stroke-width="1.5625" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
